import { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./login.css";

const LoginPage = () => {
  const { isAuthenticated, userRole, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && userRole) {
      navigate("/afas");
    }
  }, [isAuthenticated, userRole, navigate]);

  return (
    <div className="loginContainer">
      <div className="login"></div>

      <div className="loginbutton">
        <button className="login-button" onClick={login}>
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google logo"
            className="google-icon"
          />
          Inloggen met Google
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
